import { MutationTree } from "vuex";
import { MessageState, Message } from "./model";

const mutations: MutationTree<MessageState> = {
  setMessages(state, messages: Message[]) {
    state.messages = messages
  },
  setMessage(state, message: Message) {
    state.message = message
  },
}

export default mutations;
